import {EventEmitter, Injectable, Output} from '@angular/core';
import {BankPayload, UserDetails, UserService} from "./user.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class AdminService {

    @Output() groupupdate: EventEmitter<boolean> = new EventEmitter();
    private permission: string;
    constructor(private userService: UserService) {
    }
    private getMenuPermission(): string {
        this.permission = localStorage.getItem('permission');
        return this.permission;
    }
    public getPermission() {
        const token = this.getMenuPermission();
        if (token) {
            return token
        } else {
            return null;
        }
    }
    toggleGroupUpdate(data){
        this.groupupdate.emit(data.data);
    }
    public verifyMailIdAdmin(userId, captcha):Observable<any>{
        return this.userService.request('get','verifyMailIdadmin',null,{email:userId, captcha:captcha});
    }
    public resetEmail(id, captcha): Observable<any> {
        return this.userService.request('get', 'sendfpwcode', null, { email: id, captcha:captcha })
    }
    //api for fetch user groups
    public getUserGroups(): Observable<any> {
        return this.userService.request('get', 'getgroups');
    }
    // Unused endpoint - superseded by getAdminUsersList() / '/adminuserslist'
    // public getadminusersList():Observable<any> {
    //     return this.userService.userequest('get','adminuser');
    // }
    // admin user CRUD against the dedicated admins collection
    public getAdminUsersList(): Observable<any> {
        return this.userService.userequest('get', 'adminuserslist');
    }
    public createAdminUser(user): Observable<any> {
        return this.userService.userequest('post', 'createadminuser', user);
    }
    public editAdminUser(user): Observable<any> {
        return this.userService.userequest('post', 'editadminuser', user);
    }
    // Super admin only: sets just an admin's Telegram Chat ID ({ _id, telegram_chat_id, _csrf }); empty clears it
    public updateAdminTelegramChatId(obj): Observable<any> {
        return this.userService.userequest('post', 'admintelegramchatid', obj);
    }
    public updateAdminUserStatus(obj): Observable<any> {
        return this.userService.userequest('post', 'adminuserstatus', obj);
    }
    public deleteAdminUser(adminId): Observable<any> {
        return this.userService.request('get', 'deleteadminuser', null, { id: adminId });
    }
    public resetAdminBlock(obj): Observable<any> {
        return this.userService.userequest('post', 'resetadminblock', obj);
    }
    public WithdrawWhitelist(perpage,page,search,csrf):Observable<any> {
        return this.userService.userequest('post','WithdrawWhitelist', {perpage:perpage,page:page,search:search,_csrf:csrf});
    }
    public getDepositAddresses(perpage,page,search,csrf):Observable<any> {
        return this.userService.userequest('post','deposit-addresses', {perpage:perpage,page:page,search:search,_csrf:csrf});
    }
    public Whitelistaction(obj:any): Observable<any> {
        return this.userService.userequest('post', 'Whitelistaction', obj);
    }
    //api for fetch user groups
    public getAdminMenus(): Observable<any> {
        return this.userService.request('get', 'adminmenu');
    }
    public deleteAdminMenu(id): Observable<any> {
        return this.userService.request('get',  `admin-menu/${id}`);
    }
    //api call for get admin user list
    public getGroupList(perpage,page,search):Observable<any> {
        return this.userService.request('get','grouplist', null, {perpage:perpage,page:page,search:search});
    }
    public changeGroupStatus(groupid,status):Observable<any> {
        return this.userService.request('get','changegroupstatus', null, {groupid:groupid,status:status});
    }
    //api for save user groups
    public addNewGroup(object): Observable<any> {
        return this.userService.request('post', 'savegroup',object);
    }
    public addIpAddr(object): Observable<any> {
        return this.userService.request('post', 'addipaddr',object);
    }
    public IpAddrStatus(object): Observable<any> {
        return this.userService.request('post', 'addipaddrstatus',object);
    }
    public groupDelete(groupid): Observable<any> {
        return this.userService.request('get','deletegroup',null,{groupid:groupid});
    }
    public getGroupById(groupid): Observable<any> {
        return this.userService.request('get','groupbyid',null,{groupid:groupid});
    }
    public updateGroup(object): Observable<any> {
        return this.userService.request('post', 'updategroup',object);
    }
    public getAdminPanelMenus(): Observable<any> {
        return this.userService.request('get', 'menurules');
    }
    // public getAllAdmins(): Observable<any> {
    //     return this.userService.request('get', 'getalladmin');
    // }
    // Unused endpoint - not called anywhere in the app
    // public getAdminUserById(userid): Observable<any> {
    //     return this.userService.request('get','adminuserbyid',null,{userid:userid});
    // }
    public getAllIpaddr(object): Observable<any> {
        return this.userService.request('get', 'getipaddr',null,object);
    }
    public deleteIp(req):Observable<any>{
        return this.userService.request('post', 'deleteIP',req);
    }
    public deleteAllIp(req):Observable<any>{
        return this.userService.request('post', 'deleteallIP',req);
    }
    public deleteCheckedIP(req):Observable<any>{
        return this.userService.request('post', 'deletecheckedip',req);
    }
    public addCMS(req):Observable<any>{
        return this.userService.request('post', 'addcms',req);
    }
    public getCMS(object): Observable<any> {
        return this.userService.request('get', 'getcms',null,object);
    }
    public deleteCMS(req):Observable<any>{
        return this.userService.request('post', 'deletecms',req);
    }
    public deleteAllCMS(req):Observable<any>{
        return this.userService.request('post', 'deleteallcms',req);
    }
    public deleteCheckedCMS(req):Observable<any>{
        return this.userService.request('post', 'deletecheckedcms',req);
    }
    public changeIpStatus(req):Observable<any>{
        return this.userService.request('post', 'changeipstatus',req);
    }
    public updateDepositbyAdmin(obj):Observable<any> {
        return this.userService.userequest('post','updateDepositbyAdmin', obj);
    }

    public updateFiatbyAdmin(obj):Observable<any> {
        return this.userService.userequest('post','updateFiatbyAdmin', obj);
    }
    
    
}



// WEBPACK FOOTER //
// ./src/app/services/admin.service.ts